import api from "./apiConfig";

export const REGISTER_ENTERPRISE = async (data) => {
	try {
		const response = await api.post("/client", data);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const REGISTER_DEBIT_REGISTER = async (data) => {
	try {
		const response = await api.post("/debitRegister", data);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const UPDATE_DEBIT_REGISTER = async (id, data) => {
	try {
		const response = await api.put(`/debitRegister/${id}`, data);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_ENTERPRISE_BY_USER = async (id) => {
	try {
		const response = await api.get(`/clientByUser/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_FILE_TYPES = async () => {
	try {
		const response = await api.get(`/allowedFileTypes`);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_ENTERPRISES = async () => {
	try {
		const response = await api.get("/client");
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_ENTERPRISES_TAX_DEFENSE = async () => {
	try {
		const response = await api.get("/clientsByIsTaxDefenseClient");
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_ENTERPRISES_ADMIN = async (id) => {
	try {
		const response = await api.get(`/clientByAdmin/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_ENTERPRISE_BY_ACCOUNTANT = async (id) => {
	try {
		const response = await api.get(`/clientByAccountant/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_ENTERPRISE_BY_ADMIN = async (id) => {
	try {
		const response = await api.get(`/clientByAccountant/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_ENTERPRISE_BY_ID = async (id) => {
	try {
		const response = await api.get(`/client/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_NATURAL_PERSON_DOCUMENTS = async (id) => {
	try {
		const response = await api.get(`/naturalPersonByClient/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_LEGAL_ENTITIE_DOCUMENTS = async (id) => {
	try {
		const response = await api.get(`/legalEntitiesByClient/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_COMPILANCE_OPINIONS_DOCUMENTS = async (id) => {
	try {
		const response = await api.get(`/complianceOpinionsByClient/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_PROVISIONAL_PAYMENTS_DOCUMENTS = async (id) => {
	try {
		const response = await api.get(`/provisionalPaymentsByClientId/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_ANNUAL_STATEMENT_DOCUMENTS = async (id) => {
	try {
		const response = await api.get(`/annualStatementByClient/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_FINANCIAL_REPORTING = async (id) => {
	try {
		const response = await api.get(`/financialReportingByClient/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_DEBIT_REGISTER = async (id) => {
	try {
		const response = await api.get(`/debitRegisterByClient/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_MAILBOX = async (id) => {
	try {
		const response = await api.get(`/taxMailboxByClientId/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const UPDATE_NATURAL_PERSON_DOCUMENTS = async (id, data) => {
	try {
		const response = await api.put(`/naturalPerson/${id}`, data);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const UPDATE_LEGAL_ENTITIE_DOCUMENTS = async (id, data) => {
	try {
		const response = await api.put(`/legalEntities/${id}`, data);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const UPDATE_COMPILANCE_OPINIONS_DOCUMENTS = async (id, data) => {
	try {
		const response = await api.put(`/complianceOpinions/${id}`, data);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const UPDATE_PROVISIONAL_PAYMENTS_DOCUMENTS = async (id, data) => {
	try {
		const response = await api.put(`/provisionalPayments/${id}`, data);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const UPDATE_ANNUAL_STATEMENT_DOCUMENTS = async (id, data) => {
	try {
		const response = await api.put(`/annualStatement/${id}`, data);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const UPDATE_FINANCIAL_REPORTING = async (id, data) => {
	try {
		const response = await api.put(`/financialReporting/${id}`, data);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const UPDATE_MAILBOX = async (id, data) => {
	try {
		const response = await api.put(`/taxMailbox/${id}`, data);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const UPDATE_ENTERPRISE = async (id, data) => {
	try {
		const response = await api.put(`/client/${id}`, data);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const DELETE_ENTERPRISE = async (id) => {
	try {
		const response = await api.delete(`/client/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error al eliminar:", error);
		throw error;
	}
};
